import { useQuery } from '@tanstack/react-query';
import { experienceService } from '../services/experience.service';
import type { ListExperiencesParams, Experience } from '../types/experience.types';

interface UseExperiencesReturn {
  experiences: Experience[];
  hasData: boolean;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useExperiences(params: ListExperiencesParams): UseExperiencesReturn {
  const query = useQuery({
    queryKey: ['experiences', params],
    queryFn: () => experienceService.listExperiences(params),
    enabled: !!params.candidateId,
  });

  return {
    experiences: query.data ?? [],
    hasData: query.data !== undefined,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
